<template>
  <v-list-item v-if="(!edit && !onlyedit) || edit"
               :class="[compact ? 'pa-0 smallli' : '', liclass ? liclass : 'px-2']">
    <v-card v-if="clickedit"
            @click="setEdit()"
            @keydown.enter.exact="setEdit()"
            :ripple="false"
            flat
            color="transparent"
            class="clickoverlay"></v-card>
    <slot name="normalmodecontent"
          v-if="!edit && !onlyedit && !internalEdit">
      <normal-mode-template :label="label"
                            :value="correctedValue"
                            :noempty="noempty"
                            :compact="compact"
                            :searchterm="searchterm"
                            :valuetext="valuetext"
                            :suffix="suffix"
                            :valuecolor="valuecolor"
                            :loading="loading">
      </normal-mode-template>
      <empty-value-warning :value="value"
                           :noempty="noempty"
                           :loading="loading">
      </empty-value-warning>
    </slot>
    <slot name="editmodecontent"
          v-else-if="edit || internalEdit">
      <edit-mode-template :label="label"
                          :keyname="keyname"
                          :value="value"
                          :noempty="noempty"
                          :charlimit="charlimit"
                          :email="email"
                          :tlf="tlf"
                          :onlyedit="onlyedit"
                          :clickedit="clickedit"
                          :internalEdit="internalEdit"
                          :compact="compact"
                          :suffix="suffix"
                          :loading="loading"
                          @fetch="passfetch"
                          @InternalNormal="setNormal">
      </edit-mode-template>
    </slot>
  </v-list-item>
</template>


<script>
import NormalModeTemplate from "@/components/Inputs/Parts/NormalModeTemplate.vue";
import EmptyValueWarning from "@/components/Inputs/Parts/EmptyValueWarning.vue";
import EditModeTemplate from "@/components/Inputs/Parts/EditModeTemplate.vue";

export default {
  name: "SlottedEditListItem",
  props: [
    "label",
    "keyname",
    "value",
    "edit",
    "valuetext",
    "valuecolor",
    "noempty",
    "charlimit",
    "email",
    "tlf",
    "onlyedit",
    "clickedit",
    "compact",
    "suffix",
    "loading",
    "liclass",
    "searchterm",
    "overrideDisplayValue",
  ],
  components: { NormalModeTemplate, EmptyValueWarning, EditModeTemplate },

  data() {
    return {
      internalEdit: false,
      lastValue: null,
    };
  },

  mounted() {
    var firstupdate = { key: this.keyname, value: this.value };
    this.$emit("fetch", firstupdate);
    this.lastValue = firstupdate;
  },

  methods: {
    passfetch(update) {
      this.$emit("fetch", update);
      this.lastValue = update;
    },
    setEdit() {
      this.internalEdit = true;
    },
    setNormal(savebool) {
      this.internalEdit = false;
      if (savebool) {
        this.$emit("finalval", this.lastValue);
      }
    },
  },

  computed: {
    correctedValue() {
      return this.overrideDisplayValue ? this.overrideDisplayValue : this.value;
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped>
.clickoverlay {
  position: absolute;
  width: 100%;
  height: calc(100% + 16px);
  margin-top: 4px;
  margin-left: 0px;
}
.smallli {
  min-height: 16px;
}
</style>